import { isStaffPortalPath } from './utils/staffPaths';
import { staffPortalRoutes } from './admincomponents/StaffPortalRoutes';
import TenantActivityTracker from './components/TenantActivityTracker';
// src/App.js
import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './services/interceptors'; // Import the interceptors to set up global error handling
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import LDashboard from './Layout/LDashboard';
import LLandingpage from './Layout/LLandingpage';
import LLogin from './Layout/LLogin';
import LRegister from './Layout/LRegister';
import LForgetpassword from './Layout/LForgetpassword';
import LUpgrade from './Layout/LUpgrade';
import { useTheme } from "./ThemeContext";
import PageNotFound from './Layout/L404';
import BugReportForm from './components/BugReportForm';
import TermsOfService from './components/TermsOfService';
import ReportBuilderPage from './components/ReportBuilderPage';
import TemplateSelectionPage from './components/TemplateSelectionPage';
import ReportTemplatePicker from "./v2/screens/reports/ReportTemplatePicker";
import LDownloadPage from './Layout/LDownloadPage';
import { ExportQueueProvider } from './contexts/ExportQueueContext';
import GlobalExportProgressTracker from './components/GlobalExportProgressTracker';
import ScanLinkRoute from './components/ScanLinkRoute';
import PublicScan from './components/PublicScan';
import ResultsPage from './components/PipsqueakWidget';
import InternalReportPreview from './components/InternalReportPreview';
import ExternalRiskReportPage from './components/ExternalRiskReportPage';
import DownloadScanner from './components/DownloadScanner';
import MfaGate from './components/MfaGate';
import ProspectDownload from './components/ProspectDownload';
import { V2_PATHS } from './v2/shell/nav';
import axios from 'axios';
import DesktopPortalLogin, { DesktopPortalSessionProvider } from './components/DesktopPortalSession';
function App() {
  const { isDarkMode } = useTheme()
  useEffect(() => {
    if (isStaffPortalPath(window.location.pathname)) return;
    fetch("https://app.pipsqueaknetscan.com/s1/track-visit", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        page: window.location.pathname,
        user_agent: navigator.userAgent,
      }),
    }).catch(err => console.error("Visitor tracking failed", err));
  }, []);

  useEffect(() => {
  axios.interceptors.response.use(
    response => response,
    error => {
      const status = error.response?.status;
      const message = error.response?.data?.message || error.message || 'An error occurred';
      if (status === 401 && message === 'Token has expired') {
        // Handle unauthorized access - e.g., redirect to login
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
  );
}, []);
  return (
    <ExportQueueProvider>
      <Router>
        <DesktopPortalSessionProvider>
        <div className={`App ${isDarkMode ? 'bg-dark' : ''}`}>
          <MfaGate>
            <TenantActivityTracker />
            <Routes>
              <Route path="/" element={<LLogin />} />
              <Route path="/home" element={<LLogin />} />
              <Route path="/login" element={<LLogin />} />
              <Route path="/desktop-login" element={<DesktopPortalLogin />} />
              <Route path="/register" element={<LRegister />} />
              <Route path="/forgetpass" element={<LForgetpassword />} />
              {/* Shareable link into the Pro checkout; signs the visitor in first if needed. */}
              <Route path="/upgrade" element={<LUpgrade />} />
              {/* /dashboard plus every screen of the new interface (v2/shell/nav.js
                  SCREEN_PATHS), all rendering LDashboard, which picks the shell. A layout
                  route, so the shell stays mounted while moving between screens instead
                  of reloading on every click. */}
              <Route element={<LDashboard />}>
                {V2_PATHS.map((path) => <Route key={path} path={path} element={null} />)}
              </Route>
              <Route path="/report" element={<BugReportForm />} />
              <Route path="/terms" element={<TermsOfService />} />
              {staffPortalRoutes()}
              <Route path="/downloads" element={<LDownloadPage />} />
              <Route path="/report-builder" element={<ReportBuilderPage />} />
              <Route path="/prospect/download/:scanId" element={<ProspectDownload />} />
              <Route path="/scan/:token" element={<PublicScan />} />
              <Route path="/scan-links/new" element={<ScanLinkRoute />} />
              <Route path="/report-builder/template-selection" element={<TemplateSelectionPage />} />
              {/* v2 starts a report from a scan that is already chosen, so the only step left is
                  the template. The v1 two-step wizard above is untouched. */}
              <Route path="/report-builder/pick-template" element={<ReportTemplatePicker />} />
              <Route path="/download/:token" element={<DownloadScanner />} />
              <Route path="/widget" element={<ResultsPage />} />
              <Route path="/internal-report-preview" element={<InternalReportPreview />} />
              <Route path="/external-risk-report" element={<ExternalRiskReportPage />} />
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </MfaGate>

          {/* Global Export Progress Tracker - Shows on ALL pages */}
          <GlobalExportProgressTracker />
        </div>
        </DesktopPortalSessionProvider>
      </Router>
    </ExportQueueProvider>
  );
}
export default App;
